import { Button } from '@simplywallst/ui-core';

import { useTypeformDrawer } from '@/hooks/useTypeformDrawer';

export const NarrativesFeedback = () => {
  const makeTypeformPopup = useTypeformDrawer('lLagInU1');

  return (
    <div className="px-x2 pb-x1 lg:p-0">
      <span className="text-xs text-soft m-0 mr-x0_5">
        We've recently updated how you can view stocks within your watchlist.
      </span>
      <Button
        display="inline-block"
        styleType="strongLink"
        className="text-xs"
        onClick={makeTypeformPopup}
      >
        Share Feedback
      </Button>
    </div>
  );
};
